export const roundToCents = (value: number): number => Math.round(value * 100) / 100;

export const getLineDiscount = (
  lineTotal: number,
  discountPercent: number,
  discountCost: number,
  excludeInvoiceDiscount?: number | boolean,
): number => {
  const excluded = excludeInvoiceDiscount === 1 || excludeInvoiceDiscount === true;
  if (discountCost > 0 || discountPercent <= 0 || excluded) {
    return 0;
  }
  return roundToCents(lineTotal * (discountPercent / 100));
};
